import { DomainRule } from '../../types';
import { DateCantBeInThePastRule, DateCantBeInThePastRuleKey } from './DateCantBeInThePastRule';

export interface AnyDatesCantBeInThePastRuleDto {
  startDate: Date;
  endDate?: Date;
}

export const AnyDatesCantBeInThePastRule = ({ startDate, endDate }: AnyDatesCantBeInThePastRuleDto): DomainRule => {
  const result = [DateCantBeInThePastRule({ date: startDate }), DateCantBeInThePastRule({ date: endDate })].filter(
    s => s.result === 'fail',
  ).length;

  if (result) {
    return {
      result: 'fail',
      ruleKey: DateCantBeInThePastRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
